import { render, staticRenderFns } from "./EditRobots.vue?vue&type=template&id=7f786810&"
import script from "./EditRobots.vue?vue&type=script&lang=js&"
export * from "./EditRobots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports